document.addEventListener("DOMContentLoaded", function () {
  const bars = document.querySelectorAll(".animated-announcement-bar");
  bars.forEach(function (bar) {
    const slides = bar.querySelectorAll(".animated-announcement-bar__slide");
    if (slides.length < 2) return;
    let index = 0;
    let duration = bar.dataset.slideDuration ? parseInt(bar.dataset.slideDuration, 10) * 1000 : 4000;
    let animTime = 800;

    slides.forEach(function (slide, i) {
      if (i !== 0) slide.classList.remove("is-active", "is-hiding");
    });

    setInterval(() => {
      slides[index].classList.add("is-hiding");

      setTimeout(() => {
        slides[index].classList.remove("is-active", "is-hiding");
        index = (index + 1) % slides.length;
        slides[index].classList.add("is-active");
      }, animTime);
    }, duration);
  });
});
